import React, { useState } from 'react';
import { Row, Col} from "react-bootstrap"
import { useTranslation } from "react-i18next";
import { DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Panel, PanelType } from '@fluentui/react/lib/Panel';
import { useBoolean } from '@fluentui/react-hooks';
import { Dialog, DialogFooter, DialogType } from '@fluentui/react/lib/Dialog';
//import RelatedConceptInfo from '../RelatedConceptInfo';
import { useGetRelatedConceptsByType } from "../../../../hooks/services/sBook/useOfRelatedConcept"
import RelatedConceptPicker from './RelatedConceptPicker';
import CValidator from '../../../Common/CValidator';
import { _global_buttonStyles } from '../../../../common/ObjectStructures/Trasnversal';

const SidePanel = (props) => {
    const { t } = useTranslation();

    const inputParam_RelatedConcept = props.relatedConcept !== null && props.relatedConcept !== undefined ? props.relatedConcept : null;
    const inputParam_SetterRelatedConceptItem = props.setterRelatedConceptItem;
    
    const [isDialogVisible, { setTrue: showDialog, setFalse: hideDialog }] = useBoolean(false);

    const isPanelOpen = props.isPanelOpen;
    const setIsPanelOpen = props.setIsPanelOpen;

    const [selectedRelatedConcept, setSelectedRelatedConcept] = useState(null);

    const [relatedConceptList, setRelatedConceptList] = useState(null);
    useGetRelatedConceptsByType(relatedConceptList, setRelatedConceptList, inputParam_RelatedConcept, isPanelOpen);

    //#//const [relatedConceptItem, setRelatedConceptItem] = useState(null);
    //#//useGetRelatedConceptById(selectedRelatedConcept, setRelatedConceptItem, inputParam_RelatedConceptTypeId)

    const [isInvalidForm, setIsInvalidForm] = useState(false);

    const onHideDialog = (ev) => {
        ev.preventDefault();
        setIsPanelOpen(true);
        hideDialog();
    };

    const onDismissPanel = () => {
        setIsPanelOpen(false);
        setIsInvalidForm(false);
    };

    const onSelectReatedConcept = () => {
        const isValidRelatedConcept = selectedRelatedConcept !== null;

        if (isValidRelatedConcept) {
            setRelatedConceptList(null);

            //Enviar a guardar elemento relacionado seleccionado a servicio.
            inputParam_SetterRelatedConceptItem({
                relatedConceptTypeId : inputParam_RelatedConcept.relatedConceptTypeId,
                relatedConceptCode : selectedRelatedConcept.code,
                name : selectedRelatedConcept.name,
                projectId : inputParam_RelatedConcept.relatedConceptTypeId === 1 ? selectedRelatedConcept.id : null,
                contractId : inputParam_RelatedConcept.relatedConceptTypeId === 2 ? selectedRelatedConcept.id : null,
            });


            setSelectedRelatedConcept(null);
            setIsInvalidForm(false);
            onDismissPanel();
        }
        else {
            setIsInvalidForm(true);
        }
    };

    const onHideDialogAndPanel = () => {
        onDismissPanel();
        hideDialog();
        setSelectedRelatedConcept(null);

    };
    
    const onClosePanel = () => {
        setRelatedConceptList(null);
        onDismissPanel();
    };
    const onChangeRelatedConcept = (currentNode, selectedNodes) => {
        //Al establecer esta propiedad se gatilla en hook la busqueda del item relacionado "useGetRelatedConceptById".

        relatedConceptList.forEach(x => {
            x.checked = x.id === currentNode.id ? currentNode.checked : x.checked;
        })


        setRelatedConceptList(relatedConceptList);
        setSelectedRelatedConcept(currentNode);
    };
    

    const onRenderFooterContent = () => {
        return <div>
            <PrimaryButton onClick={onSelectReatedConcept} styles={_global_buttonStyles}>{t('data-lang-btn-select')}</PrimaryButton>
            <DefaultButton onClick={onClosePanel}>{t('data-lang-btn-close')}</DefaultButton>
        </div>
    };

    return (
        <div>
            {
                inputParam_RelatedConcept &&       
                <Panel
                    isOpen={ isPanelOpen }
                    isLightDismiss={ true }
                    onLightDismissClick={ showDialog }
                    onDismiss={ onDismissPanel }
                    headerText={ inputParam_RelatedConcept.relatedConceptTypeId === 1 ? t('data-lang-lbl-selectproject') : t('data-lang-lbl-selectcontract') }
                    closeButtonAriaLabel={ t('data-lang-btn-close') }
                    isFooterAtBottom={ true }
                    onRenderFooterContent={ onRenderFooterContent }
                    customWidth={ PanelType.medium }
                    type={ PanelType.medium }
                >
                    <Row className="pt-3">
                        <Col>
                            <RelatedConceptPicker
                                data={ relatedConceptList !== null ? relatedConceptList : [] }
                                mode="simpleSelect"
                                className="dropdown-checkbox"
                                isInValid={ isInvalidForm }
                                texts={{ placeholder: t('data-lang-lbl-choose') }}
                                onChange={ onChangeRelatedConcept }
                                labelText={ inputParam_RelatedConcept.relatedConceptTypeId === 1 ? t('data-lang-lbl-project') : t('data-lang-lbl-contract') }
                            />
                            <CValidator isInValid={ isInvalidForm } />
                        </Col>
                    </Row>
                </Panel>
            }
            <Dialog
                hidden={!isDialogVisible}
                onDismiss={onHideDialog}
                dialogContentProps={{
                    type: DialogType.normal,
                    title: t('data-lang-msg-close-panel'),
                }}
                modalProps={{
                    isBlocking: true,
                    styles: { main: { maxWidth: 450 } },
                }}
                >
                <DialogFooter>
                    <PrimaryButton onClick={onHideDialogAndPanel} text={t('data-lang-lbl-yes')} />
                    <DefaultButton onClick={onHideDialog} text={t('data-lang-lbl-no')} />
                </DialogFooter>
            </Dialog>
        </div>
    );
};

export default SidePanel;